import React from "react";
import ApplicationProvider from "pages/application-provider";
import { Button, Flex, Text, PasswordInput, rem, SimpleGrid, Title, Box } from "@mantine/core";
import CarouselOp from "components/login/CarouselOp";

interface Props {
    csrfToken: string;
    passwordChangeUrl: string;
    staticBaseUrl: string;
}

interface DjangoFormErrors {
    [key: string]: string[];
}

export default function PasswordChangeFormPage(props: Props) {
    const [oldPassword, setOldPassword] = React.useState('');
    const [newPassword1, setNewPassword1] = React.useState('');
    const [newPassword2, setNewPassword2] = React.useState('');
    
    const [errors, setErrors] = React.useState<DjangoFormErrors>({});

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setErrors({});

        const formData = new FormData();
        formData.append('csrfmiddlewaretoken', props.csrfToken);
        formData.append('old_password', oldPassword);
        formData.append('new_password1', newPassword1);
        formData.append('new_password2', newPassword2);

        const response = await fetch(props.passwordChangeUrl, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (response.ok) {
            window.location.href = response.url;
        } else {
            const data = await response.json();
            if (data.errors) {
                setErrors(data.errors);
            }
        }
    };

    return (
        <ApplicationProvider>
            <Flex direction='column' w={'100svw'} h={'100svh'} p={rem(16)}>
                <SimpleGrid cols={2} h={'100%'}>
                    <Flex direction={'column'} p={rem(40)} justify={'center'}>
                        <Box maw={rem(262)} pos={'absolute'} top={rem(56)} component={'a'} href={'/'}>
                            <img src={`${props.staticBaseUrl}alone/images/logo-big.svg`} alt="Alone"/>
                        </Box>

                        <Flex direction={'column'} gap={rem(24)} maw={rem(400)}>
                            <Flex direction={'column'} gap={rem(16)}>
                                <Title fw={600} fz={rem(32)} c={'#1E1E1E'}>
                                    Change Your Password
                                </Title>
                                <Title fw={500} fz={rem(18)} c={'#A3A3A3'}>
                                    Please enter your old password and choose a new one.
                                </Title>
                            </Flex>
                            
                            {errors.non_field_errors && (
                                <Text color="red" size="sm">
                                    {errors.non_field_errors.join(' ')}
                                </Text>
                            )}

                            <form onSubmit={handleSubmit}>
                                <Flex direction={'column'} gap={rem(16)}>
                                    <PasswordInput
                                        label="Old Password"
                                        size="md"
                                        variant={'filled'}
                                        placeholder="Enter your old password"
                                        value={oldPassword}
                                        onChange={(event) => setOldPassword(event.currentTarget.value)}
                                        error={errors.old_password?.[0]}
                                        required
                                    />
                                    <PasswordInput
                                        label="New Password"
                                        size="md"
                                        variant={'filled'}
                                        placeholder="Enter your new password"
                                        value={newPassword1}
                                        onChange={(event) => setNewPassword1(event.currentTarget.value)}
                                        error={errors.new_password1?.[0]}
                                        required
                                    />
                                    <PasswordInput
                                        label="Confirm New Password"
                                        size="md"
                                        variant={'filled'}
                                        placeholder="Confirm your new password"
                                        value={newPassword2}
                                        onChange={(event) => setNewPassword2(event.currentTarget.value)}
                                        error={errors.new_password2?.[0]}
                                        required
                                    />
                                </Flex>

                                <Button
                                    type={'submit'}
                                    variant={'filled'}
                                    bg={'#4B49AC'}
                                    p={rem(16)}
                                    style={{borderRadius: '12px'}}
                                    h={rem(56)}
                                    w={'100%'}
                                    mt={rem(24)}
                                >
                                    <Text c={'#FFFFFF'} fz={rem(16)} fw={500}>
                                        Change Password
                                    </Text>
                                </Button>
                            </form>
                        </Flex>
                    </Flex>
                    <CarouselOp staticBaseUrl={props.staticBaseUrl}/>
                </SimpleGrid>
            </Flex>
        </ApplicationProvider>
    );
}